export const WORKFLOW_VERSION_NO_DESCRIPTION_LABEL = 'No description';

export const getWorkflowVersionLabel = (version: number) => `v${version}`;

export const getWorkflowVersionOptionPrimaryLabel = (description?: string | null) => {
  const trimmedDescription = description?.trim();
  return trimmedDescription || WORKFLOW_VERSION_NO_DESCRIPTION_LABEL;
};

export const getWorkflowVersionOptionSecondaryLabel = (
  version: number,
  updatedRelativeTime: string,
) => `${getWorkflowVersionLabel(version)} · Updated ${updatedRelativeTime}`;
